"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledKnockRequestBackground = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var StyledKnockRequestBackground = exports.StyledKnockRequestBackground = _styledComponents["default"].ul(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 8px 0px 0px 8px;\n  background: #5c617c;\n  box-shadow: 4px 4px 8px rgba(25, 28, 41, 0.5);\n  border-radius: 4px;\n"])));